import { render, staticRenderFns } from "./work_bom.vue?vue&type=template&id=6e801666&scoped=true&"
import script from "./work_bom.vue?vue&type=script&lang=js&"
export * from "./work_bom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e801666",
  null
  
)

export default component.exports